import React, { useEffect, useState } from "react";
import {
  Form,
  Typography,
  Flex,
  Grid,
  Radio,
  Button,
  Checkbox,
  Select,
  App,
  DatePicker,
  Row,
  Col
} from "antd";
import InputField from "../../../../components/Input/Input";
import SearchAutoComplete from "../../../../components/SearchAutoComplete";
import InvoiceTable from "./InvoiceTable";
import {
  fetchCustomerList,
  fetchSalesAccounts,
  fetchDiscountAccounts,
  fetchTaxAccounts,
  fetchTransportAccounts,
  fetchCurrentStock,
  fetchPatients,
  fetchDoctors,
  fetchInsuranceCompanies,
  fetchSpecialPrices,
  fetchBatchesForItem,
  fetchPackingStructureForItem,
} from "../../salesThunks";
import { selectCustomersList } from "../../salesSelectors";
import {
  setResetSales, setSelectedCustomer, setTagFeildNameid, setPatientCopayPercent,
  setInsuranceCompanyId,
  setSelectedDoctorId,
  setShowDoctorField,
  setEntryDate,
  setDeliveryType,
  recalcPatientAmounts,
  resetPatientFlow,
  setInsuranceDueAmount,
  setPatientDueAmount,
  setIsTatmeenProduct,
  setSsccCode,
} from "../../salesSlice";
import { useDispatch, useSelector } from "react-redux";
import { fetchCustomersBalance } from "../../../Customers/customersThunks";
import { useForm } from "antd/es/form/Form";
import { useLocation, useNavigate } from "react-router-dom";
import { getCurrencyCodeWithName } from "../../../../lib/currency";
import { convertCurrency } from "../../../../utils";
import SearchListAutoComplete from "../../../../components/SearchListAutoComplete";
import dayjs from "dayjs";
import { getSalesOrderRecordWithDetailsApi, salesRecordWithDetailsApi } from "../../../../apiservice/sales";
import { fetchProductsList } from "../../../Products/productsThunks";
import { accessChecker, getAccessType } from "../../../../lib/functions";
import { clearDraft, saveDraft } from "../../../../store/commonSlices/uiDraftsSlice";
import { selectDraft } from "../../../../store/commonSelectors/uiDraftsSelectors";
import EmployeeQuickDrawer from "../../../Employees/components/EmployeeQuickDrawer";
import CustomerDrawer from "../../../Customers/components/CustomerDrawer";
import { getTagForSales } from "../../../../services/sales";
import { calculateTotals } from "../../../../utils/salesPharma";
import {
  fetchEmployees,
  fetchSingleInstitutionDetails,
  fetchTagGroupFields,
  fetchItems,
} from "../../../../store/commonThunks/lookups";
import { fetchQuotationWithDetails } from "../../../QuotationRecord/QuotationRecordThunk";

const { Title } = Typography;
const { useBreakpoint } = Grid;

const vatAndTaxOptions = [
  {
    label: "Total Item",
    value: "total",
  },
  {
    label: "Individual Item",
    value: "individual",
  },
];

const CreateInvoiceForm = ({
  onSaveSales,
  prevDues,
  salesVoucherNumber,
  salesSuccess,
  authInfo,
  editId,
  convertId,
  quoteId,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = useForm();
  const { message } = App.useApp();
  const [taxMode, setTaxMode] = useState("individual");
  const [selectedSearchedCustomer, setSelectedSearchedCustomer] =
    useState(null);
  const [selectedEmployee, setSelectedEmployee] = useState(0);
  const [isConvertCurrencyShow, SetIsConvertCurrencyShow] = useState(false);
  const [selectedSalesAcc, SetSelectedSalesAcc] = useState(null);
  const { loading, tag_field_id, entryDate, isTatmeenProduct, ssccCode, } = useSelector((state) => state.salesPharma);

  const screens = useBreakpoint();
  const [conversionRate, setConversionRate] = useState(null);
  const currency = authInfo?.currency || "AED";
  const lookups = useSelector((state) => state.lookups);
  const [selectedDiscountAcc, selectedDiscountAccSet] = useState(null);
  const [selectedTaxAcc, setSelectedTaxAcc] = useState(null);
  const [selectedTransportAcc, setSelectedTransportAcc] = useState(null);
  const [dueDate, setDueDate] = useState(null);
  const [customerDrawerOpen, setCustomerDrawerOpen] = useState(false);
  const [employeeDrawerOpen, setEmployeeDrawerOpen] = useState(false);
  const [selectedTags, setSelectedTags] = useState([]);
  const [packingMap, setPackingMap] = useState({});
  const [batchMap, setBatchMap] = useState({});

  // patient / doctor / insurance lists from redux
  const patientsList = useSelector((state) => state.salesPharma.patientsList);
  const doctorsList = useSelector((state) => state.salesPharma.doctorsList);
  const insuranceCompanies = useSelector((state) => state.salesPharma.insuranceCompanies);

  const isTatmeenUAE =
    authInfo?.is_tatmeen_enabled === "yes" &&
    authInfo?.country === "United Arab Emirates" && (authInfo?.subscription == 'PharmaERP_Pro' || authInfo?.subscription == 'PharmaERP_Standard' || authInfo?.subscription == 'PharmaERP_Basic');

  const hasTatmeenEntryAccess = accessChecker("tatmeen_entry");

  console.log(isTatmeenUAE, hasTatmeenEntryAccess, "hasTatmeenEntryAccess");

  useEffect(() => {
    // load lookups
    dispatch(fetchItems(""));
    dispatch(fetchPatients());
    dispatch(fetchDoctors());
    dispatch(fetchInsuranceCompanies());
  }, [dispatch]);


  const [itemsList, setItemsList] = useState([
    {
      key: 1,
      product: null,
      quantity: 0,
      rate: 0,
      discount: 0,
      vat: 0,
      vat_per: 0,
      total: 0,
      deliveryDate: "",

      batch_id: null,
      serial_mode: "unit",
      availableSerials: [],
      selectedSerials: [],
      child_sscc_code: "",
      is_tatmeen_required: false,
    },
  ]);

  const [footerValues, setFooterValues] = useState({
    discountPercent: 0,
    taxPercent: 0,
    serviceCharge: 0,
    paidAmount: 0,
    dueAmount: 0,
    subTotal: 0,
    description: "",
    challanText: "",
    emis: null,
    payCart: null,
    paymentMode: [],
    salesVoucherNumber: null,
  });


  let [access_type, access_type_set] = useState("");
  const location = useLocation();

  const DRAFT_KEY = "sales_entry_draft";

  const draft = useSelector((state) => selectDraft(state, DRAFT_KEY));
  const isFieldHidden = (fieldKey, pageKey = "sales_entry") => {
    return authInfo?.visibilitytabs?.some(
      (item) =>
        item.page_key === pageKey &&
        item.field_key === fieldKey
    );
  };

  useEffect(() => {
    if (!draft) return;

    // restore form
    if (draft.form) {
      const restored = { ...draft.form };
      // ensure entry_date is always dayjs or null
      if (restored.entry_date) {
        const d = dayjs(restored.entry_date);
        restored.entry_date = d.isValid() ? d : null;
      }
      form.setFieldsValue(restored);
    }
    dispatch(fetchCustomerList());
    dispatch(fetchProductsList());
    // restore full state
    if (draft.extra) {
      setSelectedSearchedCustomer(draft.extra.selectedSearchedCustomer);
      setSelectedEmployee(draft.extra.selectedEmployee);
      setTaxMode(draft.extra.taxMode);
      setItemsList(draft.extra.itemsList);
      setFooterValues(draft.extra.footerValues);
      setConversionRate(draft.extra.conversionRate);
      setDueDate(draft.extra.dueDate);

      SetSelectedSalesAcc?.(draft.extra.selectedSalesAcc);
      selectedDiscountAccSet?.(draft.extra.selectedDiscountAcc);
      setSelectedTaxAcc?.(draft.extra.selectedTaxAcc);
      setSelectedTransportAcc?.(draft.extra.selectedTransportAcc);

      dispatch(setTagFeildNameid(draft.extra.tag_field_id));
    }

    // clear snapshot
    dispatch(clearDraft(DRAFT_KEY));
  }, []);

  useEffect(() => {
    const state = location.state;

    if (state?.newCustomerId && Array.isArray(selectCustomersList)) {
      const match = selectCustomersList.find(c => c.acc_id == state.newCustomerId);

      if (match) {
        setSelectedSearchedCustomer(match);
        form.setFieldValue("search_customer", match);

        // fetch balance for invoice summary
        dispatch(fetchCustomersBalance(match.acc_id));
      }
    }
  }, [location.state, selectCustomersList]);

  useEffect(() => {
    const access = getAccessType("new_sales");
    access_type_set(access);
  }, []);

  useEffect(() => {
    dispatch(fetchEmployees());
    dispatch(fetchTagGroupFields(""));
    dispatch(fetchSalesAccounts()).then((res) => {
      if (res?.payload) {
        const salesAccount = res.payload;
        SetSelectedSalesAcc({
          acc_id: salesAccount.acc_id,
          acc_name: salesAccount.acc_name,
        });
      }
    });

    dispatch(fetchDiscountAccounts()).then((res) => {
      if (res?.payload) {
        const discountAccount = res.payload;
        selectedDiscountAccSet(discountAccount);
      }
    });

    dispatch(fetchTaxAccounts()).then((res) => {
      if (res?.payload) {
        const taxAccount = res.payload;
        setSelectedTaxAcc(taxAccount);
      }
    });
    dispatch(fetchTransportAccounts()).then((res) => {
      if (res?.payload) {
        const TransportAccount = res.payload;
        setSelectedTransportAcc(TransportAccount);
      }
    });
  }, [dispatch]);

  useEffect(() => {
    const stored = sessionStorage.getItem("SO_TO_SALES_ITEMS");
    if (stored) {
      const parsedItems = JSON.parse(stored);
      setItemsList(parsedItems);
      sessionStorage.removeItem("SO_TO_SALES_ITEMS");
    }
  }, []);


  useEffect(() => {
    dispatch(fetchEmployees());

    dispatch(fetchSalesAccounts()).then((res) => {
      if (res?.payload) {
        const salesAccount = res.payload;
        SetSelectedSalesAcc({
          acc_id: salesAccount.acc_id,
          acc_name: salesAccount.acc_name,
        });
      }
    });

    dispatch(fetchDiscountAccounts()).then((res) => {
      if (res?.payload) {
        const discountAccount = res.payload;
        selectedDiscountAccSet(discountAccount);
      }
    });

    dispatch(fetchTaxAccounts()).then((res) => {
      if (res?.payload) {
        const taxAccount = res.payload;
        setSelectedTaxAcc(taxAccount);
      }
    });
    dispatch(fetchTransportAccounts()).then((res) => {
      if (res?.payload) {
        const TransportAccount = res.payload;
        setSelectedTransportAcc(TransportAccount);
      }
    });
  }, [dispatch]);

  useEffect(() => {
    setFooterValues({
      ...footerValues,
      salesVoucherNumber,
    });
  }, [salesVoucherNumber]);

  // On Edit
  // useEffect(() => {
  //   if (!editId) return; // create mode -> skip

  //   (async () => {
  //     try {
  //       const res = await salesRecordWithDetailsApi({
  //         sale_id: editId,
  //         from: "voucher",
  //       });
  //       if (!res?.data?.length) return;

  //       const v = res.data[0];

  //       // ✅ 1. Load Accounts from API response
  //       if (v.sales_acc_id) {
  //         const salesAcc = {
  //           acc_id: v.sales_acc_id,
  //           acc_name: v.sales_acc_name || "Sales",
  //         };
  //         SetSelectedSalesAcc(salesAcc);
  //       }

  //       if (v.discount_acc_id) {
  //         const discountAcc = {
  //           acc_id: v.discount_acc_id,
  //           acc_name: v.discount_acc_name || "Discount on sale",
  //         };
  //         selectedDiscountAccSet(discountAcc);
  //       }

  //       if (v.tax_acc_id) {
  //         const taxAcc = {
  //           acc_id: v.tax_acc_id,
  //           acc_name: v.tax_acc_name || "duty and tax",
  //         };
  //         setSelectedTaxAcc(taxAcc);
  //       }

  //       if (v.transport_acc_id) {
  //         const transportAcc = {
  //           acc_id: v.transport_acc_id,
  //           acc_name: v.transport_acc_name || "Transport Cost on Sales ",
  //         };
  //         setSelectedTransportAcc(transportAcc);
  //       }

  //       // ✅ 2. Customer
  //       const customerObj = {
  //         acc_id: v.acc_id,
  //         acc_name: v.acc_name,
  //         contact_no: v.contact_no,
  //         institution_name: v.institution_name || "",
  //         address: v.address,
  //         acc_code: v.acc_code,
  //         display_text: v.display_text || `${v.acc_name} - ${v.acc_code}`,
  //       };

  //       setSelectedSearchedCustomer(customerObj);
  //       dispatch(setSelectedCustomer(customerObj));
  //       form.setFieldValue("search_customer", customerObj);

  //       if (v.acc_id) {
  //         dispatch(fetchCustomersBalance(v.acc_id));
  //       }

  //       // ✅ 3. Employee
  //       if (v.employee_id && v.employee_id > 0) {
  //         setSelectedEmployee(v.employee_id);
  //         await dispatch(fetchEmployees()).unwrap();
  //         const employees = lookups.employees || [];
  //         const employee = employees.find(e => e.employee_id === v.employee_id);
  //         if (employee) {
  //           form.setFieldValue("employee_id", {
  //             sale_id: v.employee_id,
  //             display_text: employee.employee_name,
  //           });
  //         }
  //       }

  //       // ✅ 4. Entry Date
  //       if (v.created_date) {
  //         const entryDate = dayjs(v.created_date);
  //         dispatch(setEntryDate(entryDate.format("DD/MM/YYYY")));
  //         form.setFieldValue("entry_date", entryDate);
  //       }

  //       if (editId) {
  //         try {
  //           const tagsResponse = await getTagForSales({
  //             tab_id: editId,
  //             type: "sales_entry"
  //           })



  //           if (tagsResponse?.data?.data?.length > 0) {

  //             const formattedTags = tagsResponse.data.data?.map(item => ({
  //               id: item.tag_field_id,
  //               display_text: `${item.group_name}/${item.display_text}`,
  //               raw: item,
  //             }));

  //             const tagOptions = formattedTags.map(item => ({
  //               label: item.display_text,
  //               value: item.display_text,
  //               tagid: item.id,
  //             }));

  //             // ✅ values for Select
  //             const selectedValues = tagOptions.map(t => t.value);

  //             // ✅ ids for redux
  //             const tagIds = tagOptions.map(t => t.tagid);

  //             setSelectedTags(selectedValues);          // UI selection
  //             dispatch(setTagFeildNameid(tagIds));      // Redux storage
  //           }

  //         } catch (tagError) {
  //           console.error("Failed to load tags for sale:", tagError);
  //         }
  //       }

  //       // ✅ 5. Items with Packing and Batch Data
  //       const itemsWithData = await Promise.all(
  //         (v.details || []).map(async (d, index) => {
  //           // Check if item is bonus
  //           const isBonus = parseFloat(d.item_rate) === 0 ||
  //             parseFloat(d.item_qty) === 0 ||
  //             d.is_bonus === "yes" ||
  //             d.is_bonus === 1 ||
  //             d.is_bonus === true;

  //           // For bonus items, rate should be 0
  //           let finalRate = isBonus ? 0 : parseFloat(d.item_rate);

  //           // For non-bonus items, fetch special price
  //           if (!isBonus && v.acc_id && parseFloat(d.item_rate) > 0) {
  //             try {
  //               const specialPriceRes = await dispatch(
  //                 fetchSpecialPrices({
  //                   item_id: d.item_id,
  //                   account_id: v.acc_id,
  //                 })
  //               ).unwrap();
  //               if (specialPriceRes && specialPriceRes.length > 0 && specialPriceRes[0]?.price) {
  //                 finalRate = parseFloat(specialPriceRes[0].price);
  //               }
  //             } catch (err) {
  //               console.error("Failed to load special price:", err);
  //             }
  //           }

  //           // Fetch stock info for each item (only for non-bonus items)
  //           let itemInfo = null;
  //           if (!isBonus) {
  //             try {
  //               const stockRes = await dispatch(
  //                 fetchCurrentStock({
  //                   itemId: d.item_id,
  //                   warehouseId: 0,
  //                 })
  //               ).unwrap();
  //               itemInfo = stockRes || null;
  //             } catch (err) {
  //               console.error("Failed to load stock for item:", d.item_id, err);
  //             }
  //           }

  //           // ✅ PACKING STRUCTURE DATA FROM API
  //           let packingData = [];
  //           let packing_name = null;
  //           let packing_quantity = null;
  //           let packing_name_quantity = null;

  //           // Check if API has packing data (from your response: pack_type, pack_defined_qty, pack_qty)
  //           if (d.pack_type && d.pack_defined_qty && d.pack_qty) {
  //             packing_name = d.pack_type;
  //             packing_name_quantity = parseFloat(d.pack_defined_qty);
  //             packing_quantity = parseFloat(d.pack_qty);

  //             // Create packing structure data for UI
  //             packingData = [{
  //               name: d.pack_type,
  //               qty: parseFloat(d.pack_defined_qty),
  //               product_id: d.item_id
  //             }];

  //             // Also fetch additional packing options if needed
  //             try {
  //               const packingRes = await dispatch(
  //                 fetchPackingStructureForItem({ product_id: d.item_id })
  //               ).unwrap();
  //               if (packingRes && packingRes.length > 0) {
  //                 packingData = packingRes;
  //                 // Update packingMap for the component
  //                 setPackingMap(prev => ({
  //                   ...prev,
  //                   [d.item_id]: packingRes || []
  //                 }));
  //               }
  //             } catch (err) {
  //               console.error("Failed to load packing structure:", err);
  //             }
  //           } else {
  //             // No packing in API, fetch available options
  //             try {
  //               const packingRes = await dispatch(
  //                 fetchPackingStructureForItem({ product_id: d.item_id })
  //               ).unwrap();
  //               packingData = packingRes || [];
  //               setPackingMap(prev => ({
  //                 ...prev,
  //                 [d.item_id]: packingRes || []
  //               }));
  //             } catch (err) {
  //               console.error("Failed to load packing structure:", err);
  //             }
  //           }

  //           // ✅ BATCH DATA FROM API
  //           let batchData = [];
  //           let batch_name = d.batch_name || null;
  //           let batch_id = d.batch_id || null;
  //           let batch_expiry = d.batch_expiry || null;

  //           // If API has batch data
  //           if (d.batch_id && d.batch_name) {
  //             batchData = [{
  //               id: d.batch_id,
  //               batch_name: d.batch_name,
  //               batch_expiry: d.batch_expiry,
  //               quantity: d.item_qty
  //             }];

  //             // Also fetch available batches for dropdown
  //             if (!isBonus && d.item_id && parseFloat(d.item_qty) > 0) {
  //               try {
  //                 const batchRes = await dispatch(
  //                   fetchBatchesForItem({
  //                     item_id: d.item_id,
  //                     item_qty: parseFloat(d.item_qty) || 0,
  //                   })
  //                 ).unwrap();
  //                 batchData = batchRes || [];
  //                 setBatchMap(prev => ({
  //                   ...prev,
  //                   [d.item_id]: batchRes || []
  //                 }));
  //               } catch (err) {
  //                 console.error("Failed to load batches:", err);
  //               }
  //             }
  //           } else {
  //             // No batch in API, fetch available batches
  //             if (!isBonus && d.item_id && parseFloat(d.item_qty) > 0) {
  //               try {
  //                 const batchRes = await dispatch(
  //                   fetchBatchesForItem({
  //                     item_id: d.item_id,
  //                     item_qty: parseFloat(d.item_qty) || 0,
  //                   })
  //                 ).unwrap();
  //                 batchData = batchRes || [];
  //                 setBatchMap(prev => ({
  //                   ...prev,
  //                   [d.item_id]: batchRes || []
  //                 }));
  //               } catch (err) {
  //                 console.error("Failed to load batches:", err);
  //               }
  //             }
  //           }

  //           return {
  //             key: index + 1,
  //             product: {
  //               item_id: d.item_id,
  //               item_name: d.item_name,
  //               display_text: d.display_text || d.item_name,
  //               tax_per: parseFloat(d.item_tax_per) || 0,
  //               item_rate: parseFloat(d.item_rate),
  //               sale_rate: parseFloat(d.sale_rate),
  //               unit_name: d.unit_name,
  //               unit_symbol: d.unit_symbol,
  //               unit_id: d.unit_id,
  //               conversion: parseFloat(d.conversion) || 1,
  //               base_unit_name: d.base_unit_name,
  //               is_serial: d.is_serial,
  //               units: d.units || [],
  //               sale_d_id: d.sale_d_id || null,
  //             },
  //             quantity: parseFloat(d.item_qty) || 0,
  //             ordered_qty: parseFloat(d.item_qty) || 0, // For edit restriction
  //             rate: finalRate,
  //             discount_per: parseFloat(d.item_discount_per) || 0,
  //             discount: parseFloat(d.item_discount) || 0,
  //             vat_per: parseFloat(d.item_tax_per) || 0,
  //             vat: parseFloat(d.item_tax) || 0,
  //             total: parseFloat(d.item_total) || 0,
  //             bonus: isBonus,
  //             itemInfo: itemInfo,
  //             unit_id: d.unit_id,
  //             per_unit_id: d.per_unit_id,
  //             per_unit_symbol: d.per_unit_symbol,
  //             per_conversion: parseFloat(d.per_conversion) || 1,

  //             // ✅ BATCH DATA (from API)
  //             batch_id: batch_id,
  //             batch_name: batch_name,
  //             batch_expiry: batch_expiry,

  //             // ✅ PACKING DATA (from API)
  //             packing_name: packing_name,
  //             packing_quantity: packing_quantity,
  //             packing_name_quantity: packing_name_quantity,

  //             // For dropdowns
  //             packing_options: packingData,
  //             batches: batchData,
  //           };
  //         })
  //       );

  //       setItemsList(itemsWithData);

  //       // ✅ 6. Payment Data from trans array
  //       // ✅ 6. Payment Data from trans array
  //       const payCart = (v.trans || []).map((t, idx) => {

  //         let acc_type_id = "cash_in_hand";
  //         if (t.to_acc_name && t.to_acc_name.toLowerCase().includes("Cash")) {
  //           acc_type_id = "cash_in_hand"; // or "pdc" if you have a specific type
  //         } else if (t.to_acc_name && t.to_acc_name.toLowerCase().includes("pdc")) {
  //           acc_type_id = "cheque"; // or "pdc" if you have a specific type
  //         } else if (t.to_acc_name && t.to_acc_name.toLowerCase().includes("cdc")) {
  //           acc_type_id = "cheque"; // or "pdc" if you have a specific type
  //         } else {
  //           acc_type_id = "bank_account";
  //         }



  //         return {
  //           key: t.to_acc_name,
  //           type: t.to_acc_name,
  //           to_acc_name: t.to_acc_name,
  //           tran_amount: parseFloat(t.tran_amount) || 0,
  //           date: t.date || t.tran_date || v.created_date, // Note: t.date comes from API
  //           from_acc_id: t.from_acc_id || t.to_acc_id,
  //           from_acc_name: t.from_acc_name || t.to_acc_name,
  //           to_acc_id: t.to_acc_id,
  //           acc_type_id: acc_type_id, // This is now populated
  //         };
  //       });



  //       // ✅ 7. Additional Expenses from otherServiceTrans
  //       const payServiceCart = (v.otherServiceTrans || []).map((t, idx) => ({
  //         key: `expense_${idx}`,
  //         type: t.to_acc_name,
  //         to_acc_name: t.to_acc_name,
  //         tran_amount: parseFloat(t.tran_amount) || 0,
  //         date: t.tran_date || v.created_date,
  //         to_acc_id: t.to_acc_id,
  //         acc_type_id: t.acc_type_id || "direct_income",
  //       }));

  //       // ✅ 8. Determine Payment Mode
  //       const paymentMode = [];
  //       if (payCart.length > 0) {
  //         paymentMode.push("isCheque");
  //       }
  //       // ✅ FIXED: Check if EMI exists in the API response
  //       if (v.is_emi === "yes" || (v.emis && v.emis.length > 0)) {
  //         paymentMode.push("isEmi");
  //       }
  //       if (payServiceCart.length > 0 || v.other_service_cost > 0) {
  //         paymentMode.push("addExpenses");
  //       }

  //       // ✅ 9. Calculate totals
  //       const { totalSubtotal, discountAmount, taxAmount, grandTotal, dueAmount: calculatedDueAmount } = calculateTotals(
  //         v.is_cal_type === "individual" ? "individual" : "total",
  //         itemsWithData,
  //         {
  //           discountPercent: parseFloat(v.total_discount_per) || 0,
  //           taxPercent: parseFloat(v.total_tax_per) || 0,
  //           paidAmount: parseFloat(v.paid_amount) || 0,
  //           payServiceCart: payServiceCart,
  //         }
  //       );


  //       if (authInfo?.branch_company_type === "Pharmacy" || v.insurance_id) {
  //         // Set insurance company
  //         const insuranceId = v.insurance_id || v.masterData?.insurance_id;
  //         if (insuranceId) {
  //           dispatch(setInsuranceCompanyId(insuranceId));

  //           // Find insurance name for form display
  //           const insurance = insuranceCompanies.find(ic =>
  //             ic.ic_id === insuranceId || ic.id === insuranceId
  //           );
  //           if (insurance) {
  //             form.setFieldValue("insurance_company", insurance.company_name);
  //           }
  //         }

  //         // Set doctor
  //         const doctorId = v.doctor_id || v.masterData?.doctor_id;
  //         if (doctorId) {
  //           dispatch(setSelectedDoctorId(doctorId));
  //           dispatch(setShowDoctorField(true));
  //           form.setFieldValue("doctor_id", doctorId);
  //         }

  //         // Set patient copay
  //         const copayPercent = v.patient_copay_percent || v.co_pay_amount || 0;
  //         dispatch(setPatientCopayPercent(copayPercent));
  //         form.setFieldValue("patient_copay", copayPercent);

  //         // Set delivery type
  //         if (v.delivery_type) {
  //           dispatch(setDeliveryType(v.delivery_type));
  //         }

  //         // Recalculate patient amounts
  //         if (grandTotal) {
  //           dispatch(recalcPatientAmounts({ grandTotal }));
  //         }
  //       }
  //       // ✅ 10. EMI DATA HANDLING
  //       // Transform API emis array to match EmiPayment component format
  //       const emiData = (v.emis || []).map((emi, index) => ({
  //         emiNo: emi.emi_no || `${index + 1}-${v.sale_voucher_no}`,
  //         fromDate: emi.from_date,
  //         lastPayDate: emi.last_date,
  //         amount: parseFloat(emi.amount) || 0,
  //       }));

  //       // Calculate EMI amount per month from API data
  //       const emiAmount = v.emis && v.emis.length > 0
  //         ? parseFloat(v.emis[0]?.amount) || parseFloat(v.emi_amount) || 0
  //         : parseFloat(v.emi_amount) || 0;

  //       // ✅ 11. Set All Footer Values
  //       const newFooterValues = {
  //         description: v.narration || "",
  //         challanText: v.challan_text || "",
  //         paidAmount: parseFloat(v.paid_amount) || 0,
  //         paid_amount: parseFloat(v.paid_amount) || 0,
  //         dueAmount: calculatedDueAmount || parseFloat(v.due_amount) || 0,
  //         subTotal: totalSubtotal || parseFloat(v.sub_total) || 0,
  //         discountPercent: parseFloat(v.total_discount_per) || 0,
  //         taxPercent: parseFloat(v.total_tax_per) || 0,
  //         serviceCharge: parseFloat(v.other_service_cost) || 0,

  //         // Payment data
  //         payCart: payCart,
  //         payServiceCart: payServiceCart,
  //         paymentMode: paymentMode,

  //         // ✅ CORRECTED: EMI data from API
  //         emis: emiData, // Transform API emis to component format
  //         emiMonths: v.emi_month || (v.emis ? v.emis.length : 0),
  //         dayWeek: v.day_week || "0",
  //         emiAmount: emiAmount,
  //         emiDayWeek: v.day_week || "0",

  //         // Other
  //         salesVoucherNumber: v.sale_voucher_no,
  //         dueDate: v.due_date ? dayjs(v.due_date).format("DD-MM-YYYY") : "",
  //         conversion_rate: parseFloat(v.conversion_rate) || 0,
  //         conversion_currency: v.conversion_currency || "",
  //       };

  //       setFooterValues(newFooterValues);

  //       // ✅ 12. Due Date
  //       if (v.due_date) {
  //         const dueDateFormatted = dayjs(v.due_date).format("DD-MM-YYYY");
  //         setDueDate(dueDateFormatted);
  //         handleFooterChange(dueDateFormatted, "dueDate");
  //       }

  //       // ✅ 13. Tax Mode
  //       const taxModeValue = v.is_cal_type === "individual" ? "individual" : "total";
  //       setTaxMode(taxModeValue);

  //       // ✅ 14. Currency Conversion
  //       if (v.conversion_rate && parseFloat(v.conversion_rate) > 0) {
  //         setConversionRate(parseFloat(v.conversion_rate));
  //         SetIsConvertCurrencyShow(true);
  //       }

  //       // ✅ 15. Set EMI data in form if exists
  //       if (v.is_emi === "yes" && v.emi_month > 0) {
  //         // Calculate day/week value for EMI form
  //         let dayWeekValue = "0";
  //         if (calculatedDueAmount > 0 && emiAmount > 0) {
  //           dayWeekValue = (calculatedDueAmount / emiAmount).toFixed();
  //         }

  //         // If you need to set form values for EMI
  //         if (form) {
  //           // form.setFieldValue("emiMonths", v.emi_month);
  //           // form.setFieldValue("dayWeek", dayWeekValue);
  //           // form.setFieldValue("amount", emiAmount);
  //           form.setFieldValue("emiMonths", v.emi_month);
  //           form.setFieldValue("dayWeek", v.day_week);
  //           form.setFieldValue("amount", v.emi_amount);
  //         }
  //       }

  //       console.log("Edit mode initialized with EMI data:", {
  //         emiData,
  //         emiMonth: v.emi_month,
  //         emiAmount,
  //         paymentMode,
  //       });

  //     } catch (error) {
  //       console.error("Edit Load Failed:", error);
  //       message.error("Failed to load sales data for editing");
  //     }
  //   })();
  // }, [editId, dispatch, form]);


  useEffect(() => {
    if (!editId) return;

    (async () => {
      try {
        const res = await salesRecordWithDetailsApi({
          sale_id: editId,
          from: "voucher",
        });

        if (!res?.data?.length) return;
        const v = res.data[0];

        // ✅ 1. Load Accounts from API response
        if (v.sales_acc_id) {
          const salesAcc = {
            acc_id: v.sales_acc_id,
            acc_name: v.sales_acc_name || "Sales",
          };
          SetSelectedSalesAcc(salesAcc);
        }

        if (v.discount_acc_id) {
          const discountAcc = {
            acc_id: v.discount_acc_id,
            acc_name: v.discount_acc_name || "Discount on sale",
          };
          selectedDiscountAccSet(discountAcc);
        }

        if (v.tax_acc_id) {
          const taxAcc = {
            acc_id: v.tax_acc_id,
            acc_name: v.tax_acc_name || "duty and tax",
          };
          setSelectedTaxAcc(taxAcc);
        }

        if (v.transport_acc_id) {
          const transportAcc = {
            acc_id: v.transport_acc_id,
            acc_name: v.transport_acc_name || "Transport Cost on Sales ",
          };
          setSelectedTransportAcc(transportAcc);
        }

        // ✅ 2. Customer
        const customerObj = {
          acc_id: v.acc_id,
          acc_name: v.acc_name,
          contact_no: v.contact_no,
          institution_name: v.institution_name || "",
          address: v.address,
          acc_code: v.acc_code,
          display_text: v.acc_name || `${v.acc_name} - ${v.acc_code}`,
          acc_type_name: v.cust_type_name || "Customer"
        };

        setSelectedSearchedCustomer(customerObj);
        dispatch(setSelectedCustomer(customerObj));
        form.setFieldValue("search_customer", customerObj);

        if (v.acc_id) {
          dispatch(fetchCustomersBalance(v.acc_id));
        }

        let ssccCodeValue = "";
        if (v.sscc_code !== undefined && v.sscc_code !== null) {
          // If it's a boolean, convert to string
          ssccCodeValue = typeof v.sscc_code === 'string' ? v.sscc_code : String(v.sscc_code);
          // If it's "true" or "false" strings, convert appropriately
          if (ssccCodeValue === "true") ssccCodeValue = "";
          if (ssccCodeValue === "false") ssccCodeValue = "";
        } else {
          ssccCodeValue = "";
        }

        dispatch(setSsccCode(ssccCodeValue));
        form.setFieldValue("sscc_code", ssccCodeValue);

        // ✅ Fix Tatmeen Product flag
        const tatmeenValue = v.is_tatmeen_product === 1 ||
          v.is_tatmeen_product === "1" ||
          v.is_tatmeen_product === true;
        dispatch(setIsTatmeenProduct(tatmeenValue));

        // ✅ 3. Employee
        if (v.employee_id && v.employee_id > 0) {
          setSelectedEmployee(v.employee_id);
          await dispatch(fetchEmployees()).unwrap();
          const employees = lookups.employees || [];
          const employee = employees.find(e => e.employee_id == v.employee_id);
          if (employee) {
            form.setFieldValue("employee_id", {
              sale_id: v.employee_id,
              display_text: employee.employee_name,
            });
          }
        }

        // ✅ 4. Entry Date
        if (v.created_date) {
          const entryDateParsed = dayjs(v.created_date);
          dispatch(setEntryDate(entryDateParsed.toISOString())); // ✅ ISO format
          form.setFieldValue("entry_date", entryDateParsed);
        }

        // ✅ 5. Load Tags
        if (editId) {
          try {
            const tagsResponse = await getTagForSales({
              tab_id: editId,
              type: "sales_entry"
            });

            if (tagsResponse?.data?.data?.length > 0) {
              const formattedTags = tagsResponse.data.data?.map(item => ({
                id: item.tag_field_id,
                display_text: `${item.group_name}/${item.display_text}`,
                raw: item,
              }));

              const tagOptions = formattedTags.map(item => ({
                label: item.display_text,
                value: item.display_text,
                tagid: item.id,
              }));

              const selectedValues = tagOptions.map(t => t.value);
              const tagIds = tagOptions.map(t => t.tagid);

              setSelectedTags(selectedValues);
              dispatch(setTagFeildNameid(tagIds));
            }
          } catch (tagError) {
            console.error("Failed to load tags for sale:", tagError);
          }
        }

        // ✅ 6. Items Loading (Simplified based on API)
        // In CreateInvoiceForm.jsx, inside the edit useEffect
        const itemsWithData = await Promise.all(
          (v.details || []).map(async (d, index) => {
            // Check if item is bonus
            const isBonus = parseFloat(d.item_rate) === 0 ||
              parseFloat(d.item_qty) === 0 ||
              d.is_bonus === "yes" ||
              d.is_bonus === 1 ||
              d.is_bonus === true;

            // For bonus items, rate should be 0
            let finalRate = isBonus ? 0 : parseFloat(d.item_rate);

            // For non-bonus items, fetch special price
            if (!isBonus && v.acc_id && parseFloat(d.item_rate) > 0) {
              try {
                const specialPriceRes = await dispatch(
                  fetchSpecialPrices({
                    item_id: d.item_id,
                    account_id: v.acc_id,
                  })
                ).unwrap();
                if (specialPriceRes && specialPriceRes.length > 0 && specialPriceRes[0]?.price) {
                  finalRate = parseFloat(specialPriceRes[0].price);
                }
              } catch (err) {
                console.error("Failed to load special price:", err);
              }
            }

            // Fetch stock info for each item (only for non-bonus items)
            let itemInfo = null;
            if (!isBonus) {
              try {
                const stockRes = await dispatch(
                  fetchCurrentStock({
                    itemId: d.item_id,
                    warehouseId: 0,
                  })
                ).unwrap();
                itemInfo = stockRes || null;
              } catch (err) {
                console.error("Failed to load stock for item:", d.item_id, err);
              }
            }

            // ✅ PACKING STRUCTURE DATA FROM API
            let packingData = [];
            let packing_name = null;
            let packing_quantity = null;
            let packing_name_quantity = null;

            if (d.pack_type && d.pack_defined_qty && d.pack_qty) {
              packing_name = d.pack_type;
              packing_name_quantity = parseFloat(d.pack_defined_qty);
              packing_quantity = parseFloat(d.pack_qty);

              packingData = [{
                name: d.pack_type,
                qty: parseFloat(d.pack_defined_qty),
                product_id: d.item_id
              }];

              try {
                const packingRes = await dispatch(
                  fetchPackingStructureForItem({ product_id: d.item_id })
                ).unwrap();
                if (packingRes && packingRes.length > 0) {
                  packingData = packingRes;
                  setPackingMap(prev => ({
                    ...prev,
                    [d.item_id]: packingRes || []
                  }));
                }
              } catch (err) {
                console.error("Failed to load packing structure:", err);
              }
            } else {
              try {
                const packingRes = await dispatch(
                  fetchPackingStructureForItem({ product_id: d.item_id })
                ).unwrap();
                packingData = packingRes || [];
                setPackingMap(prev => ({
                  ...prev,
                  [d.item_id]: packingRes || []
                }));
              } catch (err) {
                console.error("Failed to load packing structure:", err);
              }
            }

            // ✅ BATCH DATA FROM API
            let batchData = [];
            let batch_name = d.batch_name || null;
            let batch_id = d.batch_id || null;
            let batch_expiry = d.batch_expiry || null;

            // ✅ ALWAYS include the current batch first
            if (d.batch_id && d.batch_name) {
              batchData.push({
                id: d.batch_id,
                batch_name: d.batch_name,
                batch_expiry: d.batch_expiry,
                quantity: d.item_qty,
                serial_mode: d.serial_mode || "unit"
              });
            }

            // ✅ Then fetch all available batches
            if (!isBonus && d.item_id && parseFloat(d.item_qty) > 0) {
              try {
                const batchRes = await dispatch(
                  fetchBatchesForItem({
                    item_id: d.item_id,
                    item_qty: parseFloat(d.item_qty) || 0,
                  })
                ).unwrap();

                // ✅ Merge batches, avoiding duplicates
                const existingIds = new Set(batchData.map(b => b.id));
                const additionalBatches = (batchRes || []).filter(b => !existingIds.has(b.id));
                batchData = [...batchData, ...additionalBatches];

                // ✅ Update batchMap IMMEDIATELY
                setBatchMap(prev => ({
                  ...prev,
                  [d.item_id]: batchData
                }));
              } catch (err) {
                console.error("Failed to load batches:", err);
              }
            } else {
              // ✅ If no batch in API, still fetch available batches for dropdown
              if (!isBonus && d.item_id && parseFloat(d.item_qty) > 0) {
                try {
                  const batchRes = await dispatch(
                    fetchBatchesForItem({
                      item_id: d.item_id,
                      item_qty: parseFloat(d.item_qty) || 0,
                    })
                  ).unwrap();
                  batchData = batchRes || [];
                  setBatchMap(prev => ({
                    ...prev,
                    [d.item_id]: batchRes || []
                  }));
                } catch (err) {
                  console.error("Failed to load batches:", err);
                }
              }
            }


            return {
              key: index + 1,
              product: {
                item_id: d.item_id,
                item_name: d.item_name,
                display_text: d.display_text || d.item_name,
                tax_per: parseFloat(d.item_tax_per) || 0,
                item_rate: parseFloat(d.item_rate),
                sale_rate: parseFloat(d.sale_rate),
                unit_name: d.unit_name,
                unit_symbol: d.unit_symbol,
                unit_id: d.unit_id,
                conversion: parseFloat(d.conversion) || 1,
                base_unit_name: d.base_unit_name,
                is_serial: d.is_serial,
                units: d.units || [],
                sale_d_id: d.sale_d_id || null,
              },
              sale_d_id: d.sale_d_id || null,
              item_description: d?.item_description || "",
              showDescription: !!d?.item_description || false,
              quantity: parseFloat(d.item_qty) || 0,
              ordered_qty: parseFloat(d.item_qty) || 0,
              rate: finalRate,
              discount_per: parseFloat(d.item_discount_per) || 0,
              discount: parseFloat(d.item_discount) || 0,
              vat_per: parseFloat(d.item_tax_per) || 0,
              vat: parseFloat(d.item_tax) || 0,
              total: parseFloat(d.item_total) || 0,
              bonus: isBonus,
              itemInfo: itemInfo,
              unit_id: d.unit_id,
              per_unit_id: d.per_unit_id,
              per_unit_symbol: d.per_unit_symbol,
              per_conversion: parseFloat(d.per_conversion) || 1,

              // ✅ BATCH DATA
              batch_id: batch_id,
              batch_name: batch_name,
              batch_expiry: batch_expiry,

              // ✅ PACKING DATA
              packing_name: packing_name,
              packing_quantity: packing_quantity,
              packing_name_quantity: packing_name_quantity,

              // For dropdowns
              packing_options: packingData,
              batches: batchData,

              // ✅ SERIAL DATA - THIS IS THE KEY FIX
              serial_mode: d.serial_mode || "unit",
              availableSerials: d.availableSerials || [], // ✅ Use API data
              selectedSerials: d.serials
                ? d.serials.split(",").filter(Boolean)
                : [],
              is_tatmeen_required: d.is_tatmeen_required === 1 ||
                d.is_tatmeen_required === "1" ||
                d.is_tatmeen_required === true,
              child_sscc_code: d.child_sscc_code || "",
            };
          })
        );

        setItemsList(itemsWithData);

        // ✅ 7. Payment Data
        const payCart = (v.trans || []).map((t, idx) => {
          let acc_type_id = "cash_in_hand";
          if (t.to_acc_name?.toLowerCase().includes("cash")) {
            acc_type_id = "cash_in_hand";
          } else if (t.to_acc_name?.toLowerCase().includes("pdc") || t.to_acc_name?.toLowerCase().includes("cdc")) {
            acc_type_id = "cheque";
          } else {
            acc_type_id = "bank_account";
          }

          return {
            key: t.to_acc_name || `payment_${idx}`,
            type: t.to_acc_name,
            to_acc_name: t.to_acc_name,
            tran_amount: parseFloat(t.tran_amount) || 0,
            date: t.date || t.tran_date || v.created_date,
            from_acc_id: t.from_acc_id || t.to_acc_id,
            from_acc_name: t.from_acc_name || t.to_acc_name,
            to_acc_id: t.to_acc_id,
            acc_type_id: acc_type_id,
          };
        });

        // ✅ 8. Additional Expenses
        const payServiceCart = (v.otherServiceTrans || []).map((t, idx) => ({
          key: `expense_${idx}`,
          type: t.to_acc_name,
          to_acc_name: t.to_acc_name,
          tran_amount: parseFloat(t.tran_amount) || 0,
          date: t.tran_date || v.created_date,
          to_acc_id: t.to_acc_id,
          acc_type_id: t.acc_type_id || "direct_income",
        }));

        // ✅ 9. Payment Mode
        const paymentMode = [];
        if (payCart.length > 0) {
          paymentMode.push("isCheque");
        }
        if (v.is_emi === "yes" || (v.emis && v.emis.length > 0)) {
          paymentMode.push("isEmi");
        }
        if (payServiceCart.length > 0 || v.other_service_cost > 0) {
          paymentMode.push("addExpenses");
        }

        // ✅ 10. Calculate totals
        const { totalSubtotal, discountAmount, taxAmount, grandTotal, dueAmount: calculatedDueAmount } = calculateTotals(
          v.is_cal_type === "individual" ? "individual" : "total",
          itemsWithData,
          {
            discountPercent: parseFloat(v.total_discount_per) || 0,
            taxPercent: parseFloat(v.total_tax_per) || 0,
            paidAmount: parseFloat(v.paid_amount) || 0,
            payServiceCart: payServiceCart,
          }
        );

        // ✅ 11. PHARMA FIELDS (Based on your API response)
        // Check if this is a pharma sale
        const isPharmaSale = authInfo?.branch_company_type === "Pharmacy" || v.insurance_id;

        if (isPharmaSale) {
          // Set insurance company (API has insurance_id as string "ic_1")
          if (v.insurance_id) {
            dispatch(setInsuranceCompanyId(v.insurance_id));
            // Set insurance name in form
            form.setFieldValue("insurance_company", v.company_name || "");
          }

          // Set doctor
          if (v.doctor_id) {
            dispatch(setSelectedDoctorId(v.doctor_id));
            dispatch(setShowDoctorField(true));
            form.setFieldValue("doctor_id", v.doctor_id);
          } else if (v.doctor_name) {
            // If only doctor name is available
            form.setFieldValue("doctor_name", v.doctor_name);
          }

          // Set patient copay - API has copay_amount not patient_copay_percent
          const copayPercent = parseFloat(v.copay_amount) || 0;
          dispatch(setPatientCopayPercent(copayPercent));
          form.setFieldValue("patient_copay", copayPercent);

          // Set delivery type
          if (v.delivery_type) {
            dispatch(setDeliveryType(v.delivery_type));
          }

          // Use API-provided amounts instead of recalculating
          // API already has insurance_amount and patient_amt
          dispatch({
            type: 'salesPharma/setPatientDueAmount',
            payload: parseFloat(v.patient_amt) || 0
          });

          dispatch({
            type: 'salesPharma/setInsuranceDueAmount',
            payload: parseFloat(v.insurance_amount) || 0
          });
        }
        const emiData = (v.emis || []).map((emi, index) => ({
          emiNo: emi.emi_no || `${index + 1}-${v.sale_voucher_no}`,
          fromDate: emi.from_date,
          lastPayDate: emi.last_date,
          amount: parseFloat(emi.amount) || 0,
        }));
        const emiAmount = v.emis && v.emis.length > 0
          ? parseFloat(v.emis[0]?.amount) || parseFloat(v.emi_amount) || 0
          : parseFloat(v.emi_amount) || 0;

        // ✅ 12. Footer Values
        const newFooterValues = {
          description: v.narration || "",
          challanText: v.challan_text || "",
          paidAmount: parseFloat(v.paid_amount) || 0,
          paid_amount: parseFloat(v.paid_amount) || 0,
          dueAmount: calculatedDueAmount || parseFloat(v.due_amount) || 0,
          subTotal: totalSubtotal || parseFloat(v.sub_total) || 0,
          discountPercent: parseFloat(v.total_discount_per) || 0,
          taxPercent: parseFloat(v.total_tax_per) || 0,
          serviceCharge: parseFloat(v.other_service_cost) || 0,

          // Payment data
          payCart: payCart,
          payServiceCart: payServiceCart,
          paymentMode: paymentMode,

          // EMI data
          emis: emiData,
          emiMonths: v.emi_month || 0,
          dayWeek: v.day_week || "0",
          emiAmount: parseFloat(v.emi_amount) || 0,
          emiDayWeek: v.day_week || "0",

          // Other
          salesVoucherNumber: v.sale_voucher_no,
          dueDate: v.due_date ? dayjs(v.due_date).format("DD-MM-YYYY") : "",
          conversion_rate: parseFloat(v.conversion_rate) || 0,
          conversion_currency: v.conversion_currency || "",
        };

        setFooterValues(newFooterValues);

        // ✅ 13. Due Date
        if (v.due_date) {
          const dueDateFormatted = dayjs(v.due_date).format("DD-MM-YYYY");
          setDueDate(dueDateFormatted);
          handleFooterChange(dueDateFormatted, "dueDate");
        }

        // ✅ 14. Tax Mode
        const taxModeValue = v.is_cal_type === "individual" ? "individual" : "total";
        setTaxMode(taxModeValue);

        // ✅ 15. Currency Conversion
        if (v.conversion_rate && parseFloat(v.conversion_rate) > 0) {
          setConversionRate(parseFloat(v.conversion_rate));
          SetIsConvertCurrencyShow(true);
        }
        if (v.is_emi === "yes" && v.emi_month > 0) {
          // Calculate day/week value for EMI form
          let dayWeekValue = "0";
          if (calculatedDueAmount > 0 && emiAmount > 0) {
            dayWeekValue = (calculatedDueAmount / emiAmount).toFixed();
          }

          // If you need to set form values for EMI
          if (form) {
            // form.setFieldValue("emiMonths", v.emi_month);
            // form.setFieldValue("dayWeek", dayWeekValue);
            // form.setFieldValue("amount", emiAmount);
            form.setFieldValue("emiMonths", v.emi_month);
            form.setFieldValue("dayWeek", v.day_week);
            form.setFieldValue("amount", v.emi_amount);
          }
        }
      } catch (error) {
        console.error("Edit Load Failed:", error);
        message.error("Failed to load sales data for editing");
      }
    })();
  }, [editId, dispatch, form]);
  useEffect(() => {
    if (!quoteId) return;

    const loadQuotation = async () => {
      try {
        const res = await dispatch(fetchQuotationWithDetails(quoteId)).unwrap();
        const q = res[0];

        const customerObj = {
          acc_code: q?.acc_code,
          acc_id: q.acc_id,
          acc_name: q.acc_name,
          acc_type_id: q?.acc_type_id || 0,
          acc_type_name: q?.acc_type_name || "",
          address: q.address,
          contact_no: q.contact_no,
          country_code: q?.country_code || "1",
          credit_day: q?.credit_day || null,
          credit_limit: q?.credit_limit || 0,
          credit_month: q?.credit_month || "",
          display_text: `${q.acc_name} - ${q.acc_code}`,
          employee_id: q?.employee_id || 0,
          group_name: q?.group_name || null,
          institution_name: q.institution_name,
          party_type: q?.party_type || "",
        };

        form.setFieldValue("search_customer", customerObj);
        handleSelect(customerObj);

        const mappedItems = await Promise.all(
          q?.details.map(async (d, index) => {
            const stockRes = await dispatch(
              fetchCurrentStock({ itemId: d.item_id, warehouseId: 0 })
            ).unwrap();

            const isBonus =
              d.is_bonus === 1 ||
              d.is_bonus === "yes" ||
              d.is_bonus === true ||
              parseFloat(d.item_rate) === 0;

            // ✅ Fetch full product metadata here, inside Promise.all
            let fullProduct = null;
            try {
              const productFullList = await dispatch(
                fetchProductsList({
                  query: d.item_name,
                  search: false,
                  partyType: "general",
                })
              ).unwrap();
              fullProduct = productFullList.find((p) => p.item_id === d.item_id);
            } catch (err) {
              console.error("Failed to fetch product metadata:", err);
            }

            const quotationRate = parseFloat(d.item_rate) || 0; // 190 for non-bonus, 0 for bonus

            return {
              key: index + 1,
              product: {
                // ✅ Spread full product metadata first (units, tax_per, etc.)
                ...(fullProduct || {}),
                // ✅ Then override rates with quotation values — never let master overwrite
                item_id: d.item_id,
                item_name: d.item_name,
                display_text: d.item_name,
                tax_per: d.item_tax_per,
                item_rate: quotationRate,
                sale_rate: quotationRate,        // ✅ 190, not 120
                moh_invoice_rate: quotationRate, // ✅ 190, so bonus useEffect uses this
              },
              quantity: d.item_qty,
              itemInfo: stockRes || null,
              rate: isBonus ? 0 : quotationRate, // ✅ 190 for non-bonus
              item_description: d?.item_description || "",
              showDescription: !!d?.item_description,
              discount_per: d.item_discount_per,
              vat: isBonus
                ? 0
                : (d.item_qty * quotationRate -
                  (d.item_discount_per / 100) * d.item_qty * quotationRate) *
                (d.item_tax_per / 100),
              vat_per: d.item_tax_per,
              bonus: isBonus,
              batch_id: null,
              serial_mode: "unit",
              availableSerials: [],
              selectedSerials: [],
            };
          })
        );

        setItemsList(mappedItems);

        // ✅ DELETE the entire separate enrichment block below — no longer needed
        // q.details.forEach(async (item, index) => { ... }) ← REMOVE THIS
        console.log('Mapped Items:', mappedItems);
        setItemsList(mappedItems);

        // // ✅ Load full product metadata
        // q.details.forEach(async (item, index) => {
        //   const productFullList = await dispatch(
        //     fetchProductsList({
        //       query: item.item_name,
        //       search: false,
        //       partyType: "general",
        //     })
        //   ).unwrap();

        //   const full = productFullList.find((p) => p.item_id === item.item_id);
        //   if (!full) return;

        //   setItemsList((prev) => {
        //     const clone = [...prev];
        //     clone[index].product = {
        //       ...full,
        //       moh_invoice_rate: parseFloat(item.moh_invoice_rate) || 0,
        //     };
        //     return clone;
        //   });

        //   const stockRes = await dispatch(
        //     fetchCurrentStock({ itemId: item.item_id, warehouseId: 0 })
        //   ).unwrap();

        //   if (stockRes) {
        //     setItemsList((prev) => {
        //       const clone = [...prev];
        //       clone[index].itemInfo = stockRes;
        //       return clone;
        //     });
        //   }
        // });

        const payServiceCart = (q.otherServiceTrans || []).map((t, idx) => ({
          key: `expense_${idx}`,
          type: t.to_acc_name,
          to_acc_name: t.to_acc_name,
          tran_amount: parseFloat(t.tran_amount) || 0,
          to_acc_id: t.to_acc_id,
          from_acc_id: q.acc_id,
          acc_type_id: t.acc_type_id || "direct_income",
        }));

        setFooterValues((prev) => ({
          ...prev,
          description: q.narration || "",
          serviceCharge: 0,
          payServiceCart,
          addExpenses: payServiceCart.length > 0,
          paymentMode: payServiceCart.length > 0 ? ["addExpenses"] : [],
        }));

        // ✅ "total" not "on_total" for pharma
        setTaxMode(q.is_cal_type === "total" ? "total" : "individual");

        let computedDueDate = null;
        if (customerObj.credit_day != null) {
          computedDueDate = dayjs()
            .add(customerObj.credit_day, "day")
            .format("DD-MM-YYYY");
        } else if (customerObj.credit_month != null) {
          const today = new Date();
          let year = today.getFullYear();
          let month = today.getMonth() + customerObj.credit_month;
          while (month > 11) { month -= 12; year++; }
          const lastDay = new Date(year, month + 1, 0).getDate();
          computedDueDate = dayjs(new Date(year, month, lastDay)).format("DD-MM-YYYY");
        }

        if (computedDueDate) {
          setDueDate(computedDueDate);
          handleFooterChange(computedDueDate, "dueDate");
        }

      } catch (error) {
        console.log("Failed to load quotation:", error);
      }
    };

    loadQuotation();
  }, [quoteId, dispatch, form]);
  // on SALES ORDER to SALES conversion
  useEffect(() => {
    if (!convertId) return;

    let isMounted = true;

    async function loadOrder() {
      const res = await getSalesOrderRecordWithDetailsApi({ sale_o_id: convertId });
      const order = res.data[0];

      if (!order || !isMounted) return;

      // ✅ Guard: already fully converted
      if (order.status === "converted") {
        message.error("This Sales Order is already fully converted.");
        navigate("/sales");
        return;
      }

      // ✅ Set customer
      const customerObj = {
        acc_code: order?.acc_code,
        acc_id: order?.acc_id,
        acc_name: order?.acc_name,
        acc_type_id: order?.acc_type_id || 0,
        acc_type_name: order?.acc_type_name || "",
        address: order?.address,
        contact_no: order?.contact_no,
        country_code: order?.country_code || "1",
        credit_day: order?.credit_day || null,
        credit_limit: order?.credit_limit || 0,
        credit_month: order?.credit_month || "",
        display_text: order?.acc_name,
        employee_id: order?.employee_id || 0,
        group_name: order?.group_name || null,
        institution_name: order?.institution_name,
        party_type: order?.party_type || "",
      };

      handleSelect(customerObj);
      dispatch(setSelectedCustomer(customerObj));
      form.setFieldValue("search_customer", customerObj);

      // ✅ Map items with remaining qty + bonus detection same as Sales
      const mappedItems = await Promise.all(
        order.details.map(async (item, index) => {
          const orderedQty = Number(item.item_qty);
          const convertedQty = Number(item.converted_qty || 0);
          const remainingQty = orderedQty - convertedQty;

          if (remainingQty <= 0) return null;

          // ✅ Same bonus detection as Sales — rate 0 = bonus
          const isBonus = parseFloat(item.item_rate) === 0;

          let itemInfo = null;
          try {
            const stockRes = await dispatch(
              fetchCurrentStock({ itemId: item.item_id, warehouseId: 0 })
            ).unwrap();
            itemInfo = stockRes || null;
          } catch (err) {
            console.error("Failed stock fetch:", err);
          }

          return {
            key: index + 1,
            product: {
              item_id: item.item_id,
              item_name: item.item_name,
              display_text: item.item_name,
              tax_per: parseFloat(item.item_tax_per) || 0,
              item_rate: parseFloat(item.item_rate),
              sale_rate: isBonus ? 0 : parseFloat(item.item_rate),
              moh_invoice_rate: parseFloat(item.moh_invoice_rate) || 0,
              unit_name: item.unit_name,
              unit_symbol: item.unit_symbol,
              unit_id: item.unit_id,
              conversion: parseFloat(item.conversion) || 1,
              base_unit_name: item.base_unit_name,
              is_serial: item.is_serial,
              units: item.units || [],
            },
            quantity: remainingQty,
            ordered_qty: orderedQty,
            itemInfo,
            rate: isBonus ? 0 : parseFloat(item.item_rate),
            discount: parseFloat(item.item_discount) || 0,
            discount_per: parseFloat(item.item_discount_per) || 0,
            discount_amt: parseFloat(item.item_discount) || 0,
            discountMode: item.discount_mode || "percent",
            item_description: item?.item_description || "",
            showDescription: !!item?.item_description,
            vat: isBonus
              ? 0
              : (remainingQty * parseFloat(item.item_rate) -
                (parseFloat(item.item_discount_per) / 100) *
                remainingQty *
                parseFloat(item.item_rate)) *
              (parseFloat(item.item_tax_per) / 100),
            vat_per: parseFloat(item.item_tax_per) || 0,
            bonus: isBonus,
            batch_id: null,
            serial_mode: "unit",
            availableSerials: [],
            selectedSerials: [],
          };
        })
      );

      if (!isMounted) return;

      const finalItems = mappedItems.filter(Boolean);

      if (finalItems.length === 0) {
        message.warning("No remaining quantity to convert.");
        navigate("/sales");
        return;
      }

      // ✅ Enrich with full product data from order — DO NOT fetchProductsList
      // (that overwrites the rate with product default, breaking moh_invoice_rate logic)
      const enrichedItems = finalItems.map((finalItem) => {
        const orderItem = order.details.find(
          (d) => d.item_id === finalItem.product?.item_id
        );
        if (!orderItem) return finalItem;

        return {
          ...finalItem,
          product: {
            item_id: orderItem.item_id,
            item_name: orderItem.item_name,
            display_text: orderItem.item_name,
            tax_per: parseFloat(orderItem.item_tax_per) || 0,
            item_rate: parseFloat(orderItem.item_rate),
            sale_rate: parseFloat(orderItem.sale_rate) || 0,
            moh_invoice_rate: parseFloat(orderItem.moh_invoice_rate) || 0,
            unit_name: orderItem.unit_name,
            unit_symbol: orderItem.unit_symbol,
            unit_id: orderItem.unit_id,
            conversion: parseFloat(orderItem.conversion) || 1,
            base_unit_name: orderItem.base_unit_name,
            is_serial: orderItem.is_serial,
            units: orderItem.units || [],
          },
        };
      });

      setItemsList(enrichedItems);

      // ✅ Service expenses from order
      const payServiceCart = (order.otherServiceTrans || []).map((t, idx) => ({
        key: `expense_${idx}`,
        type: t.to_acc_name,
        to_acc_name: t.to_acc_name,
        tran_amount: parseFloat(t.tran_amount) || 0,
        to_acc_id: t.to_acc_id,
        from_acc_id: order.acc_id,
        acc_type_id: t.acc_type_id || "direct_income",
      }));

      const serviceCharge = payServiceCart.reduce(
        (sum, item) => sum + parseFloat(item.tran_amount || 0),
        0
      );

      if (!isMounted) return;

      setTaxMode(order.is_cal_type === "individual" ? "individual" : "on_total");

      setFooterValues((prev) => ({
        ...prev,
        description: order.narration || "",
        serviceCharge,
        payServiceCart,
        paymentMode: payServiceCart.length > 0 ? ["addExpenses"] : [],
      }));
    }

    loadOrder();

    return () => {
      isMounted = false;
    };
  }, [convertId]);

  useEffect(() => {
    console.log("Redux:", isTatmeenProduct);
  }, [isTatmeenProduct]);

  console.log("Checkbox value:", isTatmeenProduct);
  useEffect(() => {
    if (salesSuccess?.message) {
      // modal.success({ title: salesSuccess?.message });

      form.resetFields();
      setItemsList([
        {
          key: 1,
          product: null,
          item_description: "",
          showDescription: false,
          itemInfo: null,
          quantity: 0,
          discount_per: 0,
          rate: 0,
          discount: 0,
          vat: 0,
          vat_per: 0,
          total: 0,
          deliveryDate: "",
          bonus: false,
          batch_id: null,
          serial_mode: "unit",
          availableSerials: [],
          selectedSerials: [],
          child_sscc_code: "",
        },
      ]);
      setFooterValues({
        discountPercent: 0,
        taxPercent: 0,
        serviceCharge: 0,
        paidAmount: 0,
        dueAmount: 0,
        subTotal: 0,
        description: "",
        challanText: "",
        emis: null,
        payCart: null,
        paymentMode: [],
        salesVoucherNumber: null,
        rate: 0,
        toCurrency: "",
        dueDate: "",
      });
      setSelectedSearchedCustomer(null);
      setSelectedEmployee(0);
      SetIsConvertCurrencyShow(false);
      setConversionRate(0);
      setDueDate(null);
      dispatch(setResetSales());
    }
  }, [salesSuccess]);


  // Add Row inside a table
  const handleAddRow = () => {
    setItemsList([
      ...itemsList,
      {
        key: itemsList.length + 1,
        product: "",
        item_description: "",
        showDescription: false,
        quantity: 0,
        rate: 0,
        discount: 0,
        vat: 0,
        total: 0,
        deliveryDate: null,

        batch_id: null,
        serial_mode: "unit",
        availableSerials: [],
        selectedSerials: [],
        is_tatmeen_required: false,
        child_sscc_code: "",
      },
    ]);
  };

  const handletaggroup = (values, selectedOptions) => {
    setSelectedTags(values);

    const tagIds = selectedOptions?.map(opt => opt.tagid) || [];
    dispatch(setTagFeildNameid(tagIds));
  };

  // Delete row from the table
  const handleDeleteRow = (key) => {
    setItemsList(itemsList.filter((item) => item.key !== key));
  };

  // Update itemList state based on the user's input  
  const handleInputChange = (value, key, field) => {
    const newDataSource = [...itemsList];
    const rowIndex = newDataSource.findIndex((item) => item.key === key);
    const record = newDataSource[rowIndex];

    // ✅ Restrict quantity in Sales Order Conversion Mode
    if (convertId && field === "quantity") {
      if (value > record.ordered_qty) {
        message.warning(`Max allowed quantity is ${record.ordered_qty}`);
        value = record.ordered_qty; // clamp
      }
    }

    record[field] = value;
    setItemsList(newDataSource);
  };


  // Update table footer State based on user's changes
  const handleFooterChange = (value, field) => {
    setFooterValues((prev) => {
      if (field === "payCart") {
        // const newPaidAmount = value.reduce(
        //   (sum, item) => sum + parseFloat(item.amount || 0),
        //   0
        // );

        const newPaidAmount = value
          .filter((item) => item.acc_type_id !== "cheque") // 👈 exclude cheques
          .reduce((sum, item) => sum + parseFloat(item.tran_amount || 0), 0);


        return {
          ...prev,
          payCart: value,
          paid_amount: newPaidAmount,
          paidAmount: newPaidAmount, // Sync paidAmount from paid_amount calculation
        };
      }

      return {
        ...prev,
        [field]: value,
      };
    });
  };

  let tags = lookups.tagFields.map((tag) => ({
    label: tag.display_text,
    value: tag.display_text,
    tagid: tag.id
  })) || [];


  const handleSelect = (customer) => {

    if (customer === "add_new") {
      setCustomerDrawerOpen(true);
      return;
    }
    if (customer) {
      setSelectedSearchedCustomer(customer);
      form.setFieldValue("search_customer", customer);
      dispatch(fetchCustomersBalance(customer?.acc_id));
      const today = new Date();
      let year = today.getFullYear();
      let month = today.getMonth();
      const totalDaysThisMonth = new Date(year, month + 1, 0).getDate();
      let dueDate = null;
      if (customer.credit_day != null) {
        const value = customer.credit_day;
        const dayOffset = parseInt(value, 10) || 0;

        const newDate = dayjs().add(dayOffset, "day").format("DD-MM-YYYY");

        setDueDate(newDate);
      } else if (customer.credit_month != null) {
        let targetMonth = parseInt(month) + parseInt(customer.credit_month);

        while (targetMonth > 11) {
          targetMonth -= 12;
          year += 1;
        }

        const lastMonthDays = new Date(year, targetMonth + 1, 0).getDate();

        dueDate = dayjs(new Date(year, targetMonth, lastMonthDays)).format(
          "DD-MM-YYYY"
        );
        setDueDate(dueDate);
        handleFooterChange(dueDate, "dueDate");
      }
    } else {
      form.setFieldValue("search_customer", null);
    }

    // If this is a patient account, apply patient-specific flow
    if (customer?.acc_type_name === "patient") {
      const patient = patientsList.find(p => String(p.p_id) === String(customer.acc_code));
      const copay = Number(patient?.co_pay_amount || 0);

      // set copay in redux
      dispatch(setPatientCopayPercent(copay));
      form.setFieldValue("patient_copay", copay);

      // auto-detect insurance company (if patient has one)
      const insCompany = insuranceCompanies.find(ic => ic.id === patient?.insurance_company_id);

      if (insCompany) {
        dispatch(setInsuranceCompanyId(insCompany.ic_id));
        form.setFieldValue("insurance_company", insCompany.company_name);
      } else {
        dispatch(setInsuranceCompanyId(null));
      }

      // auto-select assigned doctor (Option 1): if patient has assigned doctor, set it
      if (patient?.patient_type === "insurance") {
        dispatch(setShowDoctorField(true));
        const assignedDoctorId = patient?.assigned_doctor_id || patient?.doctor_id || null;
        if (assignedDoctorId) {
          dispatch(setSelectedDoctorId(assignedDoctorId));
          form.setFieldValue("doctor_id", assignedDoctorId);
        } else {
          // keep empty — user can change
          dispatch(setSelectedDoctorId(null));
          form.setFieldValue("doctor_id", null);
        }
      } else {
        dispatch(setShowDoctorField(false));
        dispatch(setSelectedDoctorId(null));
        form.setFieldValue("doctor_id", null);
      }
    } else {
      // not a patient - reset patient flow in redux
      // dispatch(setPatientCopayPercent(0));
      // dispatch(setInsuranceCompanyId(null));
      // dispatch(setSelectedDoctorId(null));
      // dispatch(setShowDoctorField(false));
      // form.setFieldValue("patient_copay", null);
      // form.setFieldValue("insurance_company", null);
      // form.setFieldValue("doctor_id", null);
      dispatch(resetPatientFlow());
      dispatch(setPatientDueAmount(0));
      dispatch(setInsuranceDueAmount(0));
      dispatch(setPatientCopayPercent(0));
      dispatch(setInsuranceCompanyId(null));
      dispatch(setSelectedDoctorId(null));
      dispatch(setShowDoctorField(false));
      // dispatch(setPatientDueAmount(0));       
      // dispatch(setInsuranceDueAmount(0));    

      form.setFieldValue("patient_copay", 0);
      form.setFieldValue("insurance_company", null);
      form.setFieldValue("doctor_id", null);


      setFooterValues(prev => {
        const grandTotal = prev.grandTotal || 0;
        const paidAmount = prev.paidAmount || 0;
        const prevDue = 0;

        const dueAmount = grandTotal - paidAmount + prevDue;

        return {
          ...prev,
          patientAmount: 0,
          insuranceAmount: 0,
          dueAmount: dueAmount
        };
      });
    }
  };

  //this is final submission when user click on Save button ,we validate the mandatory fields and  hit api calls to save sale
  const submitForm = async (value) => {
    try {
      await form.validateFields();

      onSaveSales(
        selectedSearchedCustomer,
        itemsList,
        footerValues,
        taxMode,
        selectedEmployee,
        selectedSalesAcc,
        selectedDiscountAcc,
        selectedTaxAcc,
        selectedTransportAcc
      );
    } catch (error) {
      console.log(error);
    }
  };

  // -------------------------
  // 🔵For Add New Button Drafting: DEEP CLONE + SANITIZE
  // -------------------------
  const isSerializable = (val) => {
    if (
      typeof val === "number" ||
      typeof val === "string" ||
      typeof val === "boolean" ||
      val === null
    )
      return true;

    if (Array.isArray(val)) return true;
    if (val && typeof val === "object") return true;

    return false;
  };

  const deepClone = (val) => {
    if (!isSerializable(val)) return null;
    if (Array.isArray(val)) return val.map(deepClone);
    if (val instanceof dayjs) return val.format("DD-MM-YYYY");
    if (typeof val === "object") {
      const obj = {};
      for (const key in val) obj[key] = deepClone(val[key]);
      return obj;
    }
    return val;
  };

  const sanitizeForRedux = (obj) => {
    const clone = deepClone(obj);
    return JSON.parse(JSON.stringify(clone)); // remove functions
  };

  const handleSaveDraftAndNavigate = (navigateTo) => {
    const formValues = form.getFieldsValue(true);

    const extra = {
      selectedSearchedCustomer,
      selectedEmployee,
      taxMode,
      itemsList,
      footerValues,
      conversionRate,
      dueDate,
      selectedSalesAcc,
      selectedDiscountAcc,
      selectedTaxAcc,
      selectedTransportAcc,
      // tag_field_id,
    };

    const sanitized = sanitizeForRedux({ form: formValues, extra });
    dispatch(saveDraft({ key: DRAFT_KEY, data: sanitized }));
    navigate(`${navigateTo}?returnUrl=${location.pathname}`);
  };

  return (
    <div className="invoice-form">
      <Title level={2} style={{ marginBottom: "32px" }}>
        {convertId
          ? "Order to Sales Conversion"
          : quoteId
            ? "Quotation to Sales Conversion"
            : "Invoice"}
      </Title>
      <Form
        form={form}
        layout="horizontal"
        style={{ width: "100%", maxWidth: "1200px" }}
        colon={false}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 18 }}
        initialValues={{ entry_date: dayjs(entryDate) }}
      >
        {/* Buttons Row */}
        {!screens.xs && <Flex
          gap={!screens.md || !screens.xl ? 10 : 80}
          justify="flex-start"
          style={{
            flexDirection: !screens.md || !screens.xl ? "column" : "row",
            width: "100%",
            marginBottom: "24px",
          }}
        >
          <Flex gap={16}>
            <Button
              size="large"
              className="traic-button"
              onClick={() => navigate(-1)}
            >
              Back
            </Button>
            {access_type == "WRITE" && <>
              <Button
                type="primary"
                size="large"
                className="traic-button"
                onClick={submitForm}
                loading={loading}
              >
                Save
              </Button>
            </>}
          </Flex>
        </Flex>}

        {/* Two Column Form Layout */}
        <Flex
          gap={!screens.md || !screens.xl ? 10 : 80}
          justify="center"
          style={{
            flexDirection: !screens.md || !screens.xl ? "column" : "row",
            width: "100%",
            marginBottom: "24px",
          }}
        >
          {/* Left Column */}
          <Flex
            vertical
            gap={10}
            style={{ width: !screens.md || !screens.xl ? "100%" : "40%" }}
          >
            <Form.Item
              // label="Search Customer"
              label={
                <span>
                  Search Customer
                </span>
              }
              name="search_customer"
              required
              rules={[{ required: true, message: "Select customer" }]}
            >
              <SearchAutoComplete
                searchThunk={(searchText) => {
                  dispatch(fetchCustomerList(searchText));
                }}
                resultSelector={selectCustomersList}
                value={selectedSearchedCustomer} // ✅ show selected customer
                onSelect={handleSelect}
                placeholder="Customer"
              />
            </Form.Item>

            <Form.Item label="Customer name">
              <InputField value={selectedSearchedCustomer?.acc_name} disabled />
            </Form.Item>

            <Form.Item label="Institution Name">
              <InputField
                value={selectedSearchedCustomer?.institution_name}
                disabled
              />
            </Form.Item>

            <Form.Item label="Customer Address">
              <InputField value={selectedSearchedCustomer?.address} disabled />
            </Form.Item>

            <Form.Item

              label="Entry Date"
              rules={[{ required: true, message: "Please select date" }]}
            >
              <DatePicker
                style={{ width: "100%" }}
                value={entryDate ? dayjs(entryDate) : null}
                onChange={(d) =>
                  dispatch(setEntryDate(d ? d.toISOString() : null))
                }
                format="DD/MM/YYYY"
              />
            </Form.Item>
            {taxMode == 'total' && editId && <>
              <Form.Item label="Discount">
                <Radio.Group
                  options={vatAndTaxOptions}
                  onChange={(e) => setTaxMode(e.target.value)}
                  value={taxMode}
                />
              </Form.Item>
            </>}
            {isTatmeenUAE && hasTatmeenEntryAccess && <>
              <Form.Item
                label="sscc code"
                name="sscc_code"
                style={{ marginBottom: 0 }}
              >
                <InputField
                  placeholder="Enter SSCC Code"
                  value={ssccCode}
                  onChange={(e) =>
                    dispatch(setSsccCode(e.target.value))
                  }
                />
              </Form.Item>
            </>}


            {isTatmeenUAE && hasTatmeenEntryAccess && <>
              <Form.Item style={{ marginBottom: 0 }}>
                <Checkbox
                  checked={isTatmeenProduct}
                  disabled={!!editId}
                  onChange={(e) =>
                    dispatch(setIsTatmeenProduct(e.target.checked))
                  }
                >
                  Tatmeen Product
                </Checkbox>
              </Form.Item>
            </>}
          </Flex>

          {/* Right Column */}
          <Flex
            vertical
            gap={10}
            style={{ width: !screens.md || !screens.xl ? "100%" : "40%" }}
          >
            <Form.Item label="Previous Due">
              <InputField value={Number(prevDues).toFixed(2)} disabled />
            </Form.Item>

            <Form.Item label="Contact No">
              <InputField
                value={selectedSearchedCustomer?.contact_no}
                disabled
              />
            </Form.Item>

            <Form.Item label="Invoice No">
              <InputField value={footerValues.salesVoucherNumber} disabled />
            </Form.Item>

            <Form.Item label="Choose Employee">
              {/* <InputField  />
               */}
              <SearchListAutoComplete
                entityType="employee"
                value={
                  lookups?.employees?.map((e) => ({
                    sale_id: e.employee_id,
                    display_text: e.employee_name,
                    raw: e,
                  }))
                    .find((e) => e.sale_id === selectedEmployee) || null
                }
                optionsList={lookups.employees.map((e) => ({
                  sale_id: e.employee_id || null,
                  display_text: e.employee_name || null,
                  raw: e
                }))}
                onSelect={(val) => {
                  if (val === "add_new") {
                    setEmployeeDrawerOpen(true);
                    return;
                  }

                  setSelectedEmployee(val?.sale_id || null);
                  form.setFieldsValue({
                    employee_id: val?.sale_id || null,
                  });
                }}
                placeholder="Employee"
                showAddNew={true}
              />
            </Form.Item>

            <Form.Item label="Search Tags">
              <Select
                data-testid="roles-select"
                mode="multiple"
                style={{ width: "100%" }}
                placeholder="Select Tags"
                options={tags}
                value={selectedTags}
                onChange={handletaggroup}
              />
            </Form.Item>

            <Form.Item>
              <Checkbox
                onChange={(e) => {
                  SetIsConvertCurrencyShow(e.target.checked ? true : false);
                }}
              >
                Convert Currency
              </Checkbox>
            </Form.Item>

          </Flex>
        </Flex>

        {/* VAT / Discount */}

        <Flex
          gap={!screens.md || !screens.xl ? 10 : 80}
          justify="center"
          style={{
            flexDirection: !screens.md || !screens.xl ? "column" : "row",
            width: "100%",
            marginBottom: "24px",
          }}
        >
          {isConvertCurrencyShow && (
            <>
              <Flex
                vertical
                gap={10}
                style={{
                  width: !screens.md || !screens.xl ? "100%" : "40%",
                }}
              >
                <Form.Item label="Choose Currency">
                  <Select
                    showSearch
                    placeholder="Select Currency"
                    style={{ minWidth: 200 }}
                    options={getCurrencyCodeWithName().map((c) => ({
                      value: c.code,
                      label: `${c.currency} (${c.code})`,
                    }))}
                    onChange={async (toCurrency) => {
                      const rate = await convertCurrency(currency, toCurrency);
                      if (rate) {
                        // store conversion rate once for use in InvoiceTable
                        handleFooterChange(rate, "conversion_rate");
                        handleFooterChange(toCurrency, "conversion_currency");
                        setConversionRate(rate);
                      }
                    }}
                  />
                </Form.Item>
              </Flex>
              <Flex
                vertical
                gap={10}
                style={{
                  width: !screens.md || !screens.xl ? "100%" : "40%",
                }}
              >
                <Form.Item label="Conversion Rate">
                  <InputField value={conversionRate} disabled />
                </Form.Item>
              </Flex>
            </>
          )}
        </Flex>
      </Form>

      <div style={{ width: "100%", maxWidth: "1300px" }}>
        <InvoiceTable
          taxMode={taxMode}
          handleFooterChange={handleFooterChange}
          handleInputChange={handleInputChange}
          handleDeleteRow={handleDeleteRow}
          handleAddRow={handleAddRow}
          handleSaveDraftAndNavigate={handleSaveDraftAndNavigate}
          footerValues={footerValues}
          itemsList={itemsList}
          authInfo={authInfo}
          selectedSearchedCustomer={selectedSearchedCustomer}
          conversionRate={conversionRate}
          dueDate={dueDate}
          editId={editId}
          isEditMode={!!editId}
          isTatmeenProduct={isTatmeenProduct}
        />
      </div>

      <Flex style={{ marginBottom: "32px", width: "25%" }} gap={32}>
        <Button
          size="large"
          // shape="default"
          onClick={() => navigate(-1)}
          className="traic-button"
        >
          Back
        </Button>
        {access_type == "WRITE" && <>
          <Button
            type="primary"
            size="large"
            className="traic-button"
            onClick={submitForm}
            loading={loading}
            disabled={false}
          >
            Save
          </Button>
        </>}
      </Flex>

      <CustomerDrawer
        open={customerDrawerOpen}
        onClose={() => setCustomerDrawerOpen(false)}
        authInfo={authInfo}
        onCreated={(customer) => {
          if (!customer) return;
          // 1️⃣ Build the object SearchAutoComplete expects
          const customerObj = {
            ...customer,
            display_text: `${customer.acc_name} - ${customer.acc_code}`,
          };
          // 2️⃣ Update local state          
          setSelectedSearchedCustomer(customerObj);
          // 3️⃣ Update form field
          form.setFieldValue("search_customer", customerObj);
          // 4️⃣ Load dependent data (same as normal select)
          dispatch(fetchCustomersBalance(customer.acc_id));
        }}
      />

      <EmployeeQuickDrawer
        open={employeeDrawerOpen}
        onClose={() => setEmployeeDrawerOpen(false)}
        onCreated={async (employee) => {
          if (!employee?.employee_id) return;

          // 1️⃣ Refresh employee list
          const updated = await dispatch(fetchEmployees()).unwrap();

          // 2️⃣ Find newly created employee
          const created = updated.find(
            (e) => e.employee_id == employee.employee_id
          );

          if (!created) return;

          // 3️⃣ Build option object expected by SearchListAutoComplete
          const option = {
            sale_id: created.employee_id,
            display_text: created.employee_name,
            raw: created,
          };

          // 4️⃣ Update local + form state
          setSelectedEmployee(created.employee_id);

          form.setFieldsValue({
            employee_id: created.employee_id,
          });

          // 5️⃣ IMPORTANT: force-select in SearchListAutoComplete
          form.setFieldValue("employee_id", option);

          setEmployeeDrawerOpen(false);

        }}
      />

    </div>
  );
};

export default CreateInvoiceForm;
